const ArrowCircleLeftIcon = () => (
    <svg width="16" height="16" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.5 7.99995C17.2554 6.24017 16.4391 4.60961 15.1766 3.35945C13.9142 2.10928 12.2758 1.30887 10.5137 1.0815C8.75159 0.854137 6.96362 1.21243 5.4252 2.1012C3.88678 2.98996 2.68325 4.35989 2 5.99995M1.5 1.99995V5.99995H5.5M1.5 10C1.74456 11.7598 2.56093 13.3903 3.82336 14.6405C5.08579 15.8907 6.72424 16.6911 8.48633 16.9184C10.2484 17.1458 12.0364 16.7875 13.5748 15.8988C15.1132 15.01 16.3168 13.6401 17 12M17.5 16V12H13.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

export default ArrowCircleLeftIcon;
